﻿import './../scss/style.scss';

const randomChar = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789(^)!?[]{}*&^%$#@%*+-';
    return chars[Math.floor(Math.random() * chars.length)];
};

const onIntersection = (entries, opts) => {
    entries.forEach(entry => {
        if (entry.target.classList.contains('eyes')) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-inViewport');
            }
        } else if (entry.target.classList.contains('title')) {
            if (entry.isIntersecting) {
                let val = entry.target.dataset.string;
                let isNumber = entry.target.dataset.isnumber === 'True';
                if (entry.target.isAnimated) return;
                entry.target.isAnimated = true;
                if (isNumber) {
                    let duration = 2000;
                    let startTimestamp = null;
                    const step = (timestamp) => {
                        if (!startTimestamp) startTimestamp = timestamp;
                        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                        entry.target.innerHTML = Math.floor(progress * val.replace('.', '')).toLocaleString('nl-NL');
                        if (progress < 1) {
                            window.requestAnimationFrame(step);
                        }
                    };
                    window.requestAnimationFrame(step);
                } else {
                    let dim = entry.target.getBoundingClientRect();
                    entry.target.style.cssText = `
                        width: ${dim.width}px; 
                        height: ${dim.height}px;
                        overflow: hidden;
                        display: inline-block;
                    `;

                    const tot = val.length;
                    const chars = [...val];
                    let ch = 0;
                    let solvedArray = Array(tot).fill(null);
                    let randomizedArray = Array(tot).fill(' ');
                    let iteration = 0;

                    entry.target.textContent = randomizedArray.join('');

                    entry.target._itv = setInterval(() => {
                        while (chars[ch] === ' ' && ch < tot) {
                            solvedArray[ch] = ' ';
                            randomizedArray[ch] = ' ';
                            ch++;
                        }

                        if (ch < tot && iteration < 10) {
                            randomizedArray[ch] = randomChar();
                            iteration++;
                        } else if (ch < tot) {
                            solvedArray[ch] = chars[ch];
                            randomizedArray[ch] = chars[ch];
                            ch++;
                            iteration = 0;
                        }

                        entry.target.textContent = randomizedArray.join('');

                        if (ch === tot) {
                            clearInterval(entry.target._itv);
                        }
                    }, 20);
                }
            }
        } else {
            entry.target.classList.toggle('is-inViewport', entry.isIntersecting);
        }
    });
};

export const observer = new IntersectionObserver(onIntersection, {
    root: null,
    threshold: 0.5
});

import './vendor/bulma-collapsible.js';
import './vendor/swiper.js';
import './vendor/vanilla-js-datepicker.js';
import './project/cover.js';
//import './project/fileInput.js';
import './project/hamburger.js';
import './project/modal.js';
import './project/navbar.js';
//import './project/recaptcha.js';
import './project/observer.js';
import './project/videoControl.js';
import './project/advertisement.js';
